module.exports = function(_string, length) {
    if (!_string) return;

    var copy = _string;

    _string = _string.substring(0, length);
    _string += copy.length > length ? "…" : "";

    return _string;
};
